<template>
  <v-container fluid>
    <v-card flat color="background">
      <v-card-text>
        <v-text-field v-model="group.name" label="Group Name"></v-text-field>
        <v-textarea v-model="group.description" label="Group Description" auto-grow rows="1"></v-textarea>
      </v-card-text>
    </v-card>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="saveChanges" class="text-capitalize" color="primary">Save Changes</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import { LocationGroupAPI } from '@/clients/locationGroups/locationGroups.api'
export default {
  mounted() {
    this.getLocationGroupDetails()
  },
  data() {
    return {
      group: {}
    }
  },
  methods: {
    async getLocationGroupDetails() {
      let response
      try {
        response = await LocationGroupAPI.getLocationGroupById(this.$route.params.id)
      } catch (error) {
        return console.log(error)
      }
      this.group = response.data.payload
    },
    async saveChanges() {
      try {
        await LocationGroupAPI.updateLocationGroup({ groupId: this.$route.params.id, data: this.group })
      } catch (error) {
        return console.log(error)
      }
      this.swal({ title: 'Success', text: 'Group details updated successfully', timer: 3000 })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
